<div class="myMenu">
  <div class="menu-container">
    <div
      class="button-row"
      style="
        margin-top: 20px;
        margin-bottom: 30px;
        margin-left: 25px;
        font-size: larger;
      "
    >
      Admin Dashboard
    </div>
    <span class="button-row" style="margin-top: 20px">
      <button
        type="button"
        [matMenuTriggerFor]="tt"
        class="bet_time"
        mat-button
        style="width: 100%; text-align: start"
        class="white"
      >
        <mat-icon>format_list_bulleted</mat-icon>
        <span class="item-title" style="padding-top: 2px">Article</span>
      </button>
      <mat-menu #tt="matMenu">
        <button mat-menu-item routerLink="admin/article/0/1">Ajouter</button>
        <button mat-menu-item routerLink="admin/liste/article">Liste</button>
      </mat-menu>
    </span>
    <span class="button-row">
      <button
        routerLink="admin/categorie"
        type="button"
        class="bet_time"
        mat-button
        style="width: 100%; text-align: start"
        class="white"
      >
        <mat-icon>device_hub</mat-icon>
        <span class="item-title" style="padding-top: 2px">Catégorie</span>
      </button>
    </span>
    <span class="button-row">
      <button
        type="button"
        routerLink="admin/caracteristique"
        class="bet_time"
        mat-button
        style="width: 100%; text-align: start"
        class="white"
      >
        <mat-icon>playlist_add</mat-icon>
        <span class="item-title" style="padding-top: 2px"
          >Caracteristiques</span
        >
      </button>
    </span>
    <span class="button-row">
      <button
        type="button"
        routerLink="admin/modelcaracteristique"
        class="bet_time"
        mat-button
        style="width: 100%; text-align: start"
        class="white"
      >
        <mat-icon>bookmark</mat-icon>
        <span class="item-title" style="padding-top: 2px"
          >Modèle de caractéristiques</span
        >
      </button>
    </span>
    <span class="button-row">
      <button
        type="button"
        routerLink="admin/groupe/categorie"
        class="bet_time"
        mat-button
        style="width: 100%; text-align: start"
        class="white"
      >
        <mat-icon>device_hub</mat-icon>
        <span class="item-title" style="padding-top: 2px"
          >Groupe catégories</span
        >
      </button>
    </span>
    <span class="button-row">
      <button
        type="button"
        routerLink="link"
        class="bet_time"
        mat-button
        style="width: 100%; text-align: start"
        class="white"
      >
        <mat-icon>screen_share</mat-icon>
        <span class="item-title" style="padding-top: 2px">Image et vidéo</span>
      </button>
    </span>
    <span class="button-row">
      <button
        type="button"
        routerLink="admin/banniere"
        class="bet_time"
        mat-button
        style="width: 100%; text-align: start"
        class="white"
      >
        <mat-icon>screen_share</mat-icon>
        <span class="item-title" style="padding-top: 2px">Bannière</span>
      </button>
    </span>
    <span class="button-row">
      <button
        type="button"
        routerLink="admin/marque"
        class="bet_time"
        mat-button
        style="width: 100%; text-align: start"
        class="white"
      >
        <mat-icon>screen_share</mat-icon>
        <span class="item-title" style="padding-top: 2px">Marque</span>
      </button>
    </span>
    <span class="button-row">
      <button
        type="button"
        routerLink="content/manager"
        class="bet_time"
        mat-button
        style="width: 100%; text-align: start"
        class="white"
      >
        <mat-icon>filter</mat-icon>
        <span class="item-title" style="padding-top: 2px"
          >Gestionnaire de contenu</span
        >
      </button>
    </span>
    <span class="button-row">
      <button
        type="button"
        routerLink="blogues"
        class="bet_time"
        mat-button
        style="width: 100%; text-align: start"
        class="white"
      >
        <mat-icon>comment</mat-icon>
        <span class="item-title" style="padding-top: 2px">Blogues</span>
      </button>
    </span>
    <span class="button-row">
      <button
        type="button"
        routerLink="equipe/travail"
        class="bet_time"
        mat-button
        style="width: 100%; text-align: start"
        class="white"
      >
        <mat-icon>group</mat-icon>
        <span class="item-title" style="padding-top: 2px"
          >Équipe de travail</span
        >
      </button>
    </span>
    <span class="button-row">
      <button
        type="button"
        routerLink="commandes"
        class="bet_time"
        mat-button
        style="width: 100%; text-align: start"
        class="white"
      >
        <mat-icon>list</mat-icon>
        <span class="item-title" style="padding-top: 2px">Commandes</span>
      </button>
    </span>
    <span class="button-row">
      <button
        type="button"
        routerLink="instagram"
        class="bet_time"
        mat-button
        style="width: 100%; text-align: start"
        class="white"
      >
        <mat-icon>social_distance</mat-icon>
        <span class="item-title" style="padding-top: 2px">Instagram</span>
      </button>
    </span>
    <span class="button-row">
      <button
        type="button"
        routerLink="admin/referencement"
        class="bet_time"
        mat-button
        style="width: 100%; text-align: start"
        class="white"
      >
        <mat-icon>scale</mat-icon>
        <span class="item-title" style="padding-top: 2px">Réferencement</span>
      </button>
    </span>
    <span class="button-row">
      <button
        routerLink="admin/settings"
        type="button"
        class="bet_time"
        mat-button
        style="width: 100%; text-align: start"
        class="white"
      >
        <mat-icon>settings</mat-icon>
        <span class="item-title" style="padding-top: 2px">Paramétres</span>
      </button>
    </span>
    <span
      class="button-row"
      style="position: absolute; bottom: 10px; width: 100%; left: 5px"
    >
      <button
        (click)="logout()"
        type="button"
        class="bet_time"
        mat-button
        style="width: 100%; text-align: start"
        class="white"
      >
        <mat-icon>logout</mat-icon>
        <span class="item-title" style="padding-top: 2px">Déconnexion</span>
      </button>
    </span>
  </div>
</div>
